import './PayBillPage.less';
import { RouteComponentProps } from 'react-router-dom';
import withRoute from '@/pages/withRoute';
import BillPayPage from './BillPayPage';

export const prefix = 'bm-p-pay-bill';

const RouteComponent: React.FC<RouteComponentProps> = props => withRoute({
  pageComponent: BillPayPage,
  routeProps: props,
  pageTitleI18nKey: '',
});
export default RouteComponent;

